var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "59px",
    viewBox: "0 0 62 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7B4C1D05-639B-466C-BB20-7717C9F8C28B-6815-0000203374260C28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-4.2%",
    width: "100.9%",
    height: "111.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.121016947,24.5533602 C0.121016947,37.9597494 11.0125427,48.7972496 24.4857635,48.7920315 C37.9384114,48.7920315 48.8432491,37.9396799 48.8432491,24.5533602 C48.8432491,11.1678433 37.9384114,0.316695836 24.4857635,0.316695836 C11.0254512,0.321111114 0.121016947,11.1586113 0.121016947,24.5650005",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.7145033%",
    cy: "48.9740728%",
    fx: "49.7145033%",
    fy: "48.9740728%",
    r: "49.1251998%",
    gradientTransform: "translate(0.497145,0.489741),scale(0.995040,1.000000),translate(-0.497145,-0.489741)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEB",
    offset: "23.29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDD",
    offset: "54.43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080C6",
    offset: "89.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077BE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.256152538,11.0201319 C4.70029844,15.7565207 11.0266613,18.6866596 18.0053056,18.6878638 C29.0158314,18.6878638 38.316791,11.413493 41.3321301,1.43295832 C37.7092859,0.512974998 33.9158078,0.0220763896 30.0041365,0.0220763896 C18.6479056,0.0401388895 8.22915278,4.17444442 0.242033894,11.0381944",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.5758217%",
    y1: "30.2011075%",
    x2: "53.3286182%",
    y2: "75.233443%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4FCFE",
    offset: "8.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6F5FD",
    offset: "23.81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7E9FB",
    offset: "43.78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D9F8",
    offset: "67.76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11C4F4",
    offset: "94.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0F3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.121016947,24.5533602 C0.121016947,37.9597494 11.0125427,48.7972496 24.4857635,48.7920315 C37.9384114,48.7920315 48.8432491,37.9396799 48.8432491,24.5533602 C48.8432491,11.1678433 37.9384114,0.316695836 24.4857635,0.316695836 C11.0254512,0.321111114 0.121016947,11.1586113 0.121016947,24.5650005",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.256152538,11.0201319 C4.70029844,15.7565207 11.0266613,18.6866596 18.0053056,18.6878638 C29.0158314,18.6878638 38.316791,11.413493 41.3321301,1.43295832 C37.7092859,0.512974998 33.9158078,0.0220763896 30.0041365,0.0220763896 C18.6479056,0.0401388895 8.22915278,4.17444442 0.242033894,11.0381944",
    id: "path-10"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visuals",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Billing---Issuer-details",
    transform: "translate(-187.000000, -51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Header-/-2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-logo",
    transform: "translate(190.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "airmiles-logo",
    transform: "translate(0.949153, 0.472222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.166102, 0.118056)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7488856,25.2853037 C50.7488856,39.1356284 39.4636515,50.3652852 25.5458953,50.3721088 C11.6265256,50.3721088 0.342905073,39.1424521 0.342905073,25.2921273 C0.342905073,11.4426054 11.6265256,0.214152784 25.5458953,0.214152784 C39.4636515,0.210138895 50.7654246,11.4490276 50.7654246,25.296944",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.949153, 0.944444)",
    fill: "#00B3F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9542288,24.3408601 C48.9542288,37.7271797 38.0497945,48.5795313 24.5971466,48.5847493 C11.1449021,48.5847493 0.240064415,37.7323978 0.240064415,24.3460781 C0.240064415,10.9605613 11.1449021,0.109815276 24.5971466,0.109815276 C38.0493911,0.108611109 48.9691542,10.9461113 48.9691542,24.3525004",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.233898, 0.850000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "url(#radialGradient-4)",
    fillRule: "nonzero",
    mask: "url(#mask-3)",
    x: 0.121016947,
    y: 0.321111114,
    width: 48.7294917,
    height: 48.4877779
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.166102, 3.895833)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(5.220339, 25.027778)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26297976,4.29760007 L4.08790516,4.25063757 C3.72485431,3.49642784 3.41626108,2.71452227 3.16091531,1.91736392 L3.98423397,1.09170696 L3.72848482,0.0830166646 L0.0935389824,3.8087084 L0.54815933,4.95266675 L5.7777052,5.21236537 L5.26297976,4.29760007 Z M2.51952539,2.55236106 C2.7131525,3.1143055 2.9229152,3.67624995 3.16494909,4.2092944 L0.934606806,4.12700968 L2.51952539,2.55958606 L2.51952539,2.55236106 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(3.796610, 22.194444)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(2.581190, 0.990825) rotate(-5.019622) translate(-2.581190, -0.990825) ",
    x: 0.301957223,
    y: 0.529211733,
    width: 4.55846599,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(3.796610, 14.638889)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53583748,1.8352209 L5.94285784,0.678016687 L3.66693233,1.68148895 C3.6798408,1.59960561 3.68589165,1.51812366 3.68589165,1.43744449 C3.6879086,0.877506972 3.35995265,0.340850007 2.66733229,0.165443056 C2.50557296,0.124501388 2.35712549,0.104431943 2.2219899,0.104431943 C1.44990173,0.10523472 1.1013729,0.745851412 0.881122046,1.61887228 C0.648769494,2.52681398 0.472084742,3.46164874 0.359942364,4.41655294 L0.357925415,4.44264322 L4.84079678,5.23899881 L4.95858661,4.31941683 L3.20545434,4.00593209 C3.27282045,3.57443902 3.35551536,3.14655845 3.45031198,2.72790982 L5.53583748,1.8352209 Z M2.44909825,3.84939029 L1.25869488,3.63665418 C1.3530881,3.05504168 1.47007115,2.48185835 1.61004742,1.91590002 C1.75849487,1.32264725 1.91904402,1.02120419 2.25910164,1.02280975 C2.31718978,1.02280975 2.38011859,1.02280975 2.46079656,1.05090697 C2.78108807,1.13118475 2.90452536,1.2917403 2.90452536,1.57271252 C2.90452536,1.7396903 2.86539655,1.94600419 2.80367791,2.19566808 C2.64837282,2.74597224 2.55559316,3.30791668 2.43457622,3.82972223 L2.44909825,3.84939029 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(12.338983, 1.416667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "7.28474566 4.24763902 5.22745755 0.193611109 4.01728808 0.715416682 4.33999994 4.20750013 1.51627116 2.08013895 0.427118633 2.84277786 2.8071186 6.69611133 3.4928813 6.21444464 1.67762709 3.28430566 4.6627118 5.49194462 5.26779653 5.1708335 4.94508467 1.4780556 6.47796601 4.56875014"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(20.881356, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(1.304792, 2.641050) rotate(-10.113190) translate(-1.304792, -2.641050) ",
    x: 0.840875981,
    y: 0.373117516,
    width: 1,
    height: 4.53586581
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(25.627119, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.94460674,4.22934045 C3.01116268,4.01459739 2.05593557,3.87491405 1.08537965,3.81430432 L1.3729966,0.133568057 L0.440762707,0.0914222217 L0.086586439,4.61226547 L0.116437286,4.61306824 C1.37622372,4.61306824 2.61745421,4.77362381 3.78728471,5.05419465 L3.81794234,5.06101826 L3.95065759,4.2349599 L3.94460674,4.22934045 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(30.847458, 1.416667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92598628,1.80558895 C4.7803592,1.11038337 3.5560711,0.510708351 2.25554233,0.0254291665 L2.23093555,0.0165986106 L0.36162713,4.1553196 L0.391477977,4.16535432 C1.62302709,4.60688211 2.7714779,5.16882658 3.82029143,5.83834327 L3.84691516,5.8552016 L4.23295921,5.14313769 L4.2095626,5.12908908 C3.37454568,4.60286822 2.48668469,4.13846126 1.54799658,3.74911403 L2.01633216,2.72717788 C2.81423722,3.048289 3.58955245,3.4496779 4.31565413,3.86993209 L4.34187446,3.88558625 L4.72751513,3.17593067 L4.70290835,3.16148067 C3.95784736,2.7263751 3.17648128,2.33421814 2.36123046,1.99263618 L2.76946095,1.09874309 C3.73880669,1.500132 4.6653931,1.98179868 5.5528507,2.51564593 L5.57907104,2.53170148 L5.96309814,1.81883479 L5.92598628,1.80558895 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(36.542373, 5.194444)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43116607,1.13375834 C4.25327116,0.953936111 3.5537932,0.239865269 2.79138642,0.239062492 C2.50699659,0.238259714 2.21292541,0.339409715 1.943461,0.604326385 C1.71998304,0.822681943 1.60743728,1.09201389 1.60743728,1.39546389 C1.60864745,1.79685279 1.76879321,2.23838057 2.13184405,2.70118197 L2.77847795,3.58423753 C3.02696608,3.90534865 3.14152879,4.18632087 3.14152879,4.38701532 C3.14152879,4.49659449 3.10724066,4.58088615 3.03543727,4.65072782 C2.95838981,4.72578755 2.85794574,4.76030699 2.73934914,4.77114449 C2.44890846,4.77194727 2.04874575,4.54596532 1.69497287,4.18591948 C1.15402711,3.63922781 1.01647118,3.21375558 1.01647118,2.89264447 C1.01647118,2.72205419 1.05681016,2.58036391 1.09795593,2.46355974 L1.10602372,2.44148335 L0.316186439,1.95861251 L0.302874574,1.98470279 C0.223406778,2.12398474 0.110457626,2.3929153 0.110457626,2.76299585 C0.110457626,3.24466253 0.31215254,3.92702365 1.07859321,4.72980143 C1.62074914,5.29174589 2.20808473,5.65299589 2.81316947,5.66022089 L2.84745761,5.66022089 C3.16976608,5.66022089 3.48521693,5.53900144 3.76718642,5.26525422 C4.00881692,5.0272306 4.12337963,4.75549032 4.12337963,4.45565282 C4.12337963,4.06630559 3.93297964,3.63561531 3.59292201,3.1696028 L2.96403727,2.30300418 C2.64334236,1.86067362 2.54451185,1.61020695 2.54451185,1.46008751 C2.54451185,1.36255 2.58323727,1.30675695 2.63608134,1.25377361 C2.71554914,1.17510139 2.81074913,1.14178611 2.91603388,1.14178611 C3.19638981,1.14018056 3.5614576,1.38261945 3.84383048,1.6880764 C4.34403387,2.20988196 4.48925421,2.57113196 4.48925421,2.89224308 C4.48925421,3.04356669 4.44891523,3.17642642 4.39082709,3.29804725 L4.37791862,3.32213058 L5.16089827,3.78854448 L5.17542031,3.76004587 C5.24157624,3.62638337 5.36703047,3.37270558 5.36703047,3.0142653 C5.39325081,2.51694446 5.18711861,1.91486112 4.42067794,1.15222222",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.000000, 6.611111)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9726966,8.63916391 C30.9726966,8.63916391 27.3700222,7.4618903 23.6624665,6.37773891 C24.3958292,6.02090418 20.7342599,5.52559029 20.3821006,5.4132014 L20.3816972,5.41801807 C12.7051891,3.16903612 2.85925069,0.216820832 2.74468798,0.162633332 C2.09805412,-0.146837502 0.496193193,0.769131945 0.134755925,1.09706667 C-0.315830491,1.49845556 0.578484714,1.93998334 0.578484714,1.94399723 C0.578484714,1.94801112 23.294575,13.4237195 23.8944156,13.4237195 C26.9819612,13.3426389 32.2094898,9.0477778 30.9589813,8.64638891",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(35.593220, 18.416667)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84219995,0.202866667 C10.8922372,1.76828337 18.3069456,3.85550564 18.4683015,3.89564453 C18.8648337,4.05620009 18.6699965,4.39697927 17.9664846,4.64704455 C16.7607524,5.08937512 15.9922948,5.14918206 15.9922948,5.14918206 C15.9922948,5.14918206 6.08141012,3.9654862 0.215718643,3.56209036 C2.46259998,2.86166673 4.56305081,1.65750003 5.85389826,0.2125",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(1.423729, 6.611111)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8362564,15.0806528 C51.7285513,15.0389083 47.951209,13.9808472 44.0169481,12.8204319 C44.5768532,12.2669167 44.7668498,11.2425722 44.4271956,10.2262555 C44.0238058,9.03694026 43.0407448,8.27430138 42.1347312,8.39552082 C42.17386,8.09207082 42.168616,7.82675276 42.1020566,7.62726249 C42.0314634,7.3559236 41.8987482,6.7562486 41.1480397,6.77190277 C40.3993482,6.78755693 37.6772737,6.8862986 37.5752161,6.88067915 C37.4731585,6.8754611 35.7656093,6.5178236 34.5167145,6.83893471 C34.1568907,6.93045138 32.6748365,7.6593736 30.8652298,8.61146804 C30.840623,8.59581388 30.8144027,8.57975832 30.7797112,8.56892082 C30.7797112,8.56892082 29.540901,8.20646665 27.5957553,7.63609304 C28.2367417,6.84455415 28.4287553,5.54004027 27.9934977,4.24515971 C27.3924468,2.4501486 25.8224536,1.35596249 24.4852164,1.80029999 C23.4864232,2.13064305 22.9043317,3.22844166 22.9249046,4.52974443 C21.9628198,4.97689166 21.0394605,5.46618471 20.7768538,5.65724582 C20.7768538,5.65724582 3.31572198,0.477322214 3.20156266,0.422331936 C2.54766776,0.109248603 0.932091524,1.03565416 0.563796617,1.38566527 C0.110789849,1.78705416 1.00752542,2.22858194 1.00752542,2.24022221 C1.00752542,2.25186249 19.3371555,11.5123055 22.8309147,13.0163097 C20.9797588,14.0571111 19.5279589,14.8960139 19.1007691,15.1838097 C17.6880979,16.1427278 17.4993115,15.4515361 17.4448538,15.4314666 C17.3565115,15.4013625 15.6183047,12.3805097 15.3871624,12.3142805 C15.163281,12.2512625 14.220559,12.9781778 14.0741285,13.3578917 C13.9986946,13.5505583 13.8768709,14.8759444 13.7764268,16.1226583 C12.4512912,16.0724847 11.1620574,16.0255222 10.9393862,16.0154875 C10.509776,15.9982278 10.224176,16.1383125 10.0765354,16.2161819 C9.93212182,16.2868264 9.77641335,16.4124611 9.62715911,16.5778333 C9.47548454,16.7436069 9.52631166,17.0193611 9.78851504,17.0896041 C9.91033877,17.129743 12.2491929,17.7719653 13.6207183,18.0930764 C13.6049861,18.2961791 13.5961116,18.4173986 13.5961116,18.4173986 C13.5037353,18.9392041 13.5961116,19.5011486 14.0398404,19.5344639 C22.7086876,20.3372416 31.0741857,16.8836916 35.6691992,14.9361528 C41.4893075,15.4178194 49.3441141,16.3811528 49.3441141,16.3646958 C49.3441141,16.3482389 50.1137819,16.3024805 51.3174971,15.8633611 C52.0214123,15.5904166 52.2461005,15.2291666 51.8427107,15.0686111",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(43.661017, 16.527778)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37183384,0.432012484 C1.26816266,0.122541664 0.527942354,0.229712493 0.295589822,0.30557499 C0.0648508482,0.382240264 -0.00614575899,0.67926803 0.0979288129,0.99235135 C0.203616944,1.31346245 0.460979645,1.51415688 0.662674552,1.43106939 C0.90551522,1.33874995 1.4569491,0.736666638 1.37627113,0.415555541",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(39.389831, 17.000000)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99799668,0.65700279 C3.97258312,0.583147233 3.95685092,0.510094453 3.94273228,0.441055563 L3.94515262,0.441055563 C3.41953566,0.738083348 3.00928819,0.924327797 2.68697971,1.03711808 C2.07221359,1.80256671 1.2581729,2.565607 0.241227114,3.23351813 L0.174264401,3.28770563 C1.34046443,3.19618896 4.98710857,1.66770004 5.22188146,1.24744586 C5.16581027,1.29802086 5.09844417,1.3401667 5.02341366,1.36425003 C4.6325289,1.50875003 4.15491533,1.18763891 3.9935594,0.665833346",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(28.474576, 18.888889)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.292789837,1.40002081 L0.528772898,1.28442081 C0.63123392,1.24066943 0.713525449,1.11182359 0.7115085,1.00023749 L0.713525449,0.296201388 C0.715542399,0.183411112 0.63123392,0.128019447 0.528772898,0.174179168 L0.290772887,0.289779166 C0.188311866,0.332727776 0.107633896,0.461172218 0.107633896,0.572356938 L0.107633896,1.2775972 C0.107633896,1.3859722 0.185084747,1.42611109 0.306101702,1.3859722",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(29.423729, 18.416667)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.340413572,1.36850001 L0.576396634,1.25450557 C0.678857655,1.2099514 0.761149184,1.08110556 0.761149184,0.968716674 L0.761149184,0.265884723 C0.761149184,0.153495833 0.676840706,0.0985055545 0.576396634,0.145066666 L0.338800013,0.258659723 C0.236742381,0.30321389 0.153644072,0.429651391 0.155661021,0.542843059 L0.153644072,1.26534307 C0.152030513,1.37652779 0.244406788,1.41666668 0.325084758,1.37652779",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(25.627119, 20.305556)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.447620327,0.228602783 L0.211637282,0.342195841 C0.109176268,0.388355564 0.0252711857,0.514793066 0.0284983042,0.623168068 L0.0264813551,1.32800697 C0.0264813551,1.44842364 0.107159319,1.48856253 0.228176265,1.45123336 L0.466176258,1.33603475 C0.569444052,1.28987502 0.652945745,1.16223336 0.650928795,1.05104863 L0.653349134,0.34620973 C0.632372864,0.250277784 0.531525409,0.170000005 0.450847445,0.210138894",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(26.576271, 19.833333)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.497261027,0.197884727 L0.259664413,0.312280556 C0.155589835,0.356433333 0.0745084781,0.484877773 0.0745084781,0.593252769 L0.0728949187,1.29769024 C0.0745084781,1.41810691 0.153572886,1.45824579 0.274589837,1.41890968 L0.512186451,1.30531663 C0.612630521,1.26116386 0.695325437,1.13271942 0.695325437,1.02033053 L0.695325437,0.31468889 C0.682820352,0.200694449 0.590847469,0.160555562 0.510169502,0.200694449",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(22.305085, 20.777778)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.645803396,0.395793063 L0.408206782,0.510590286 C0.307359323,0.55594723 0.223050847,0.68278612 0.223050847,0.795977787 L0.223050847,1.49961251 C0.224664406,1.62002918 0.303728814,1.66016807 0.424745765,1.62163474 L0.66032543,1.50563335 C0.763996618,1.46107918 0.845481365,1.33223335 0.845077976,1.22064723 L0.845481365,0.517012508 C0.830959331,0.420277785 0.747457635,0.340000007 0.626440684,0.380138896",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(23.254237, 20.305556)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.695444043,0.365074989 L0.456233883,0.480674992 C0.354579649,0.52522916 0.272691517,0.651265275 0.272691517,0.765661111 L0.272691517,1.46929585 C0.272691517,1.58971252 0.35336948,1.62985141 0.474386424,1.59091669 L0.711983026,1.4749153 C0.81283048,1.42955835 0.895525392,1.30231807 0.895525392,1.19073196 L0.897138951,0.486294437 C0.87858302,0.370694434 0.806779632,0.330555544 0.685762688,0.370694434",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(31.322034, 17.472222)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.371522032,1.34720274 L0.609118634,1.23160275 C0.709966089,1.18704858 0.79427456,1.05739997 0.79427456,0.945011088 L0.79427456,0.24298194 C0.79427456,0.130191665 0.711579648,0.0760041666 0.607505075,0.12136111 L0.369908473,0.236961107 C0.269061018,0.281113883 0.186366106,0.40755138 0.186366106,0.521144432 L0.186366106,1.22397636 C0.184752546,1.31749997 0.282372882,1.39777774 0.363050846,1.35763885",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(32.271186, 17.000000)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.419549163,1.31487921 L0.65714578,1.19968059 C0.7596068,1.15472504 0.841898328,1.02708336 0.840688159,0.915095861 L0.841898328,0.211862507 C0.841898328,0.0998750033 0.7596068,0.044483335 0.655532221,0.0906430586 L0.417935604,0.205038895 C0.315877974,0.248790286 0.233989836,0.378037512 0.233989836,0.489222237 L0.232376276,1.21172226 C0.234393226,1.3080556 0.301355939,1.34819449 0.422372892,1.3080556",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(35.593220, 13.694444)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0721118654,1.07055142 C1.18546782,0.703681963 2.77926107,0.192713893 3.26292548,0.138927781 C3.26292548,0.138927781 2.49648479,0.0470097228 1.75949156,0.0185111109 C0.55819662,-0.0272472237 0.115677968,0.270984729 0.115677968,0.270984729 C0.115677968,0.270984729 -0.107800002,1.12152781 0.0854237301,1.08138892",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(26.101695, 10.388889)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24493222,2.04845272 C1.58176274,1.93766939 2.40629158,1.0566208 2.25663395,0.60425554 C2.10495937,0.155904165 1.03355595,0.31164305 0.697128816,0.421222213 C0.366349144,0.532406932 0.263888124,0.963899974 0.415159315,1.41425829 C0.565220337,1.85819439 0.904067805,2.17930549 1.22677968,2.05888883",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(20.406780, 11.333333)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34364051,1.53188895 C7.2609456,1.60654729 7.16332526,1.66434729 7.05441001,1.69244452 C6.48926087,1.88190008 5.82447445,1.41709173 5.57074225,0.65846669 C5.53363038,0.554105574 5.50983038,0.44894168 5.49369479,0.346587509 L5.49571174,0.356622232 C3.57799653,1.43796395 2.71675926,1.51623479 2.33595927,1.40023339 C2.100783,2.16608343 1.09230845,3.74273906 0.0386542375,4.47768215 C1.7284542,4.36569464 7.00237272,2.15805565 7.32508458,1.5158334",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(15.186441, 13.694444)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6793993,0.377352773 C27.3486196,1.04044722 27.034379,1.39326805 26.3937959,1.86249166 C25.6196909,2.4244361 21.6535621,5.05152637 8.83746418,9.72489719 C5.59703376,10.9073889 2.04962368,11.464918 0.774508462,11.2080291 L0.774105073,11.2080291 L0.749901683,11.2028111 C0.709562701,11.1939805 0.670433889,11.1839458 0.633725415,11.1735097 C0.545786434,11.1502291 0.425172878,11.1209277 0.282776272,11.0815916 C0.267044069,11.4829805 0.363454236,11.8040916 0.686166092,11.8442305 C9.40220993,12.6470083 17.8830775,8.91047914 22.1392435,7.10623609 C26.4184027,5.2959722 28.0759315,1.60319444 27.6725416,0.358888884",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(7.118644, 26.916667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.467932204,11.3291776 C4.95887101,16.1057053 11.3594572,19.075983 18.4187789,19.075983 C29.5474971,19.075983 38.9472866,11.7225387 41.9904593,1.63322775 C38.2937951,0.67190138 34.417219,0.157320833 30.4180124,0.157320833 C18.9593213,0.181805555 8.47118612,4.35624993 0.484067797,11.3404165",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.688136, 30.954168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_8_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "39.2901703 -8.95097219 45.4620348 17.7413878 2.3396612 27.6556929 -3.8725423 0.96333294"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(42.877965, 6.256944)",
    fill: "#0077BE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0.631186428 0.212499994 0.227796605 0.212499994 0.227796605 0.09208333 1.19593218 0.09208333 1.19593218 0.212499994 0.792542357 0.212499994 0.792542357 1.29624997 0.631186428 1.29624997"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.949153, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0.367796599 0.09208333 0.56949151 0.09208333 0.972881333 1.09555553 1.33593217 0.09208333 1.57796607 0.09208333 1.57796607 1.29624997 1.41661014 1.29624997 1.41661014 0.292777771 1.41661014 0.292777771 1.0535593 1.29624997 0.892203369 1.29624997 0.529152528 0.292777771 0.529152528 0.292777771 0.529152528 1.29624997 0.367796599 1.29624997"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-lineart-/--airmiles-logo",
    transform: "translate(0.949153, 0.472222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.166102, 0.118056)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7488856,25.2853037 C50.7488856,39.1356284 39.4636515,50.3652852 25.5458953,50.3721088 C11.6265256,50.3721088 0.342905073,39.1424521 0.342905073,25.2921273 C0.342905073,11.4426054 11.6265256,0.214152784 25.5458953,0.214152784 C39.4636515,0.210138895 50.7654246,11.4490276 50.7654246,25.296944",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.949153, 0.944444)",
    fill: "#00B3F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9542288,24.3408601 C48.9542288,37.7271797 38.0497945,48.5795313 24.5971466,48.5847493 C11.1449021,48.5847493 0.240064415,37.7323978 0.240064415,24.3460781 C0.240064415,10.9605613 11.1449021,0.109815276 24.5971466,0.109815276 C38.0493911,0.108611109 48.9691542,10.9461113 48.9691542,24.3525004",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.233898, 0.850000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "url(#radialGradient-4)",
    fillRule: "nonzero",
    mask: "url(#mask-9)",
    x: 0.121016947,
    y: 0.321111114,
    width: 48.7294917,
    height: 48.4877779
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.166102, 3.895833)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(5.220339, 25.027778)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26297976,4.29760007 L4.08790516,4.25063757 C3.72485431,3.49642784 3.41626108,2.71452227 3.16091531,1.91736392 L3.98423397,1.09170696 L3.72848482,0.0830166646 L0.0935389824,3.8087084 L0.54815933,4.95266675 L5.7777052,5.21236537 L5.26297976,4.29760007 Z M2.51952539,2.55236106 C2.7131525,3.1143055 2.9229152,3.67624995 3.16494909,4.2092944 L0.934606806,4.12700968 L2.51952539,2.55958606 L2.51952539,2.55236106 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(3.796610, 22.194444)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(2.581190, 0.990825) rotate(-5.019622) translate(-2.581190, -0.990825) ",
    x: 0.301957223,
    y: 0.529211733,
    width: 4.55846599,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(3.796610, 14.638889)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53583748,1.8352209 L5.94285784,0.678016687 L3.66693233,1.68148895 C3.6798408,1.59960561 3.68589165,1.51812366 3.68589165,1.43744449 C3.6879086,0.877506972 3.35995265,0.340850007 2.66733229,0.165443056 C2.50557296,0.124501388 2.35712549,0.104431943 2.2219899,0.104431943 C1.44990173,0.10523472 1.1013729,0.745851412 0.881122046,1.61887228 C0.648769494,2.52681398 0.472084742,3.46164874 0.359942364,4.41655294 L0.357925415,4.44264322 L4.84079678,5.23899881 L4.95858661,4.31941683 L3.20545434,4.00593209 C3.27282045,3.57443902 3.35551536,3.14655845 3.45031198,2.72790982 L5.53583748,1.8352209 Z M2.44909825,3.84939029 L1.25869488,3.63665418 C1.3530881,3.05504168 1.47007115,2.48185835 1.61004742,1.91590002 C1.75849487,1.32264725 1.91904402,1.02120419 2.25910164,1.02280975 C2.31718978,1.02280975 2.38011859,1.02280975 2.46079656,1.05090697 C2.78108807,1.13118475 2.90452536,1.2917403 2.90452536,1.57271252 C2.90452536,1.7396903 2.86539655,1.94600419 2.80367791,2.19566808 C2.64837282,2.74597224 2.55559316,3.30791668 2.43457622,3.82972223 L2.44909825,3.84939029 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(12.338983, 1.416667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "7.28474566 4.24763902 5.22745755 0.193611109 4.01728808 0.715416682 4.33999994 4.20750013 1.51627116 2.08013895 0.427118633 2.84277786 2.8071186 6.69611133 3.4928813 6.21444464 1.67762709 3.28430566 4.6627118 5.49194462 5.26779653 5.1708335 4.94508467 1.4780556 6.47796601 4.56875014"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(20.881356, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(1.304792, 2.641050) rotate(-10.113190) translate(-1.304792, -2.641050) ",
    x: 0.840875981,
    y: 0.373117516,
    width: 1,
    height: 4.53586581
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(25.627119, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.94460674,4.22934045 C3.01116268,4.01459739 2.05593557,3.87491405 1.08537965,3.81430432 L1.3729966,0.133568057 L0.440762707,0.0914222217 L0.086586439,4.61226547 L0.116437286,4.61306824 C1.37622372,4.61306824 2.61745421,4.77362381 3.78728471,5.05419465 L3.81794234,5.06101826 L3.95065759,4.2349599 L3.94460674,4.22934045 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(30.847458, 1.416667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92598628,1.80558895 C4.7803592,1.11038337 3.5560711,0.510708351 2.25554233,0.0254291665 L2.23093555,0.0165986106 L0.36162713,4.1553196 L0.391477977,4.16535432 C1.62302709,4.60688211 2.7714779,5.16882658 3.82029143,5.83834327 L3.84691516,5.8552016 L4.23295921,5.14313769 L4.2095626,5.12908908 C3.37454568,4.60286822 2.48668469,4.13846126 1.54799658,3.74911403 L2.01633216,2.72717788 C2.81423722,3.048289 3.58955245,3.4496779 4.31565413,3.86993209 L4.34187446,3.88558625 L4.72751513,3.17593067 L4.70290835,3.16148067 C3.95784736,2.7263751 3.17648128,2.33421814 2.36123046,1.99263618 L2.76946095,1.09874309 C3.73880669,1.500132 4.6653931,1.98179868 5.5528507,2.51564593 L5.57907104,2.53170148 L5.96309814,1.81883479 L5.92598628,1.80558895 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(36.542373, 5.194444)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43116607,1.13375834 C4.25327116,0.953936111 3.5537932,0.239865269 2.79138642,0.239062492 C2.50699659,0.238259714 2.21292541,0.339409715 1.943461,0.604326385 C1.71998304,0.822681943 1.60743728,1.09201389 1.60743728,1.39546389 C1.60864745,1.79685279 1.76879321,2.23838057 2.13184405,2.70118197 L2.77847795,3.58423753 C3.02696608,3.90534865 3.14152879,4.18632087 3.14152879,4.38701532 C3.14152879,4.49659449 3.10724066,4.58088615 3.03543727,4.65072782 C2.95838981,4.72578755 2.85794574,4.76030699 2.73934914,4.77114449 C2.44890846,4.77194727 2.04874575,4.54596532 1.69497287,4.18591948 C1.15402711,3.63922781 1.01647118,3.21375558 1.01647118,2.89264447 C1.01647118,2.72205419 1.05681016,2.58036391 1.09795593,2.46355974 L1.10602372,2.44148335 L0.316186439,1.95861251 L0.302874574,1.98470279 C0.223406778,2.12398474 0.110457626,2.3929153 0.110457626,2.76299585 C0.110457626,3.24466253 0.31215254,3.92702365 1.07859321,4.72980143 C1.62074914,5.29174589 2.20808473,5.65299589 2.81316947,5.66022089 L2.84745761,5.66022089 C3.16976608,5.66022089 3.48521693,5.53900144 3.76718642,5.26525422 C4.00881692,5.0272306 4.12337963,4.75549032 4.12337963,4.45565282 C4.12337963,4.06630559 3.93297964,3.63561531 3.59292201,3.1696028 L2.96403727,2.30300418 C2.64334236,1.86067362 2.54451185,1.61020695 2.54451185,1.46008751 C2.54451185,1.36255 2.58323727,1.30675695 2.63608134,1.25377361 C2.71554914,1.17510139 2.81074913,1.14178611 2.91603388,1.14178611 C3.19638981,1.14018056 3.5614576,1.38261945 3.84383048,1.6880764 C4.34403387,2.20988196 4.48925421,2.57113196 4.48925421,2.89224308 C4.48925421,3.04356669 4.44891523,3.17642642 4.39082709,3.29804725 L4.37791862,3.32213058 L5.16089827,3.78854448 L5.17542031,3.76004587 C5.24157624,3.62638337 5.36703047,3.37270558 5.36703047,3.0142653 C5.39325081,2.51694446 5.18711861,1.91486112 4.42067794,1.15222222",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.000000, 6.611111)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9726966,8.63916391 C30.9726966,8.63916391 27.3700222,7.4618903 23.6624665,6.37773891 C24.3958292,6.02090418 20.7342599,5.52559029 20.3821006,5.4132014 L20.3816972,5.41801807 C12.7051891,3.16903612 2.85925069,0.216820832 2.74468798,0.162633332 C2.09805412,-0.146837502 0.496193193,0.769131945 0.134755925,1.09706667 C-0.315830491,1.49845556 0.578484714,1.93998334 0.578484714,1.94399723 C0.578484714,1.94801112 23.294575,13.4237195 23.8944156,13.4237195 C26.9819612,13.3426389 32.2094898,9.0477778 30.9589813,8.64638891",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(35.593220, 18.416667)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84219995,0.202866667 C10.8922372,1.76828337 18.3069456,3.85550564 18.4683015,3.89564453 C18.8648337,4.05620009 18.6699965,4.39697927 17.9664846,4.64704455 C16.7607524,5.08937512 15.9922948,5.14918206 15.9922948,5.14918206 C15.9922948,5.14918206 6.08141012,3.9654862 0.215718643,3.56209036 C2.46259998,2.86166673 4.56305081,1.65750003 5.85389826,0.2125",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(1.423729, 6.611111)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8362564,15.0806528 C51.7285513,15.0389083 47.951209,13.9808472 44.0169481,12.8204319 C44.5768532,12.2669167 44.7668498,11.2425722 44.4271956,10.2262555 C44.0238058,9.03694026 43.0407448,8.27430138 42.1347312,8.39552082 C42.17386,8.09207082 42.168616,7.82675276 42.1020566,7.62726249 C42.0314634,7.3559236 41.8987482,6.7562486 41.1480397,6.77190277 C40.3993482,6.78755693 37.6772737,6.8862986 37.5752161,6.88067915 C37.4731585,6.8754611 35.7656093,6.5178236 34.5167145,6.83893471 C34.1568907,6.93045138 32.6748365,7.6593736 30.8652298,8.61146804 C30.840623,8.59581388 30.8144027,8.57975832 30.7797112,8.56892082 C30.7797112,8.56892082 29.540901,8.20646665 27.5957553,7.63609304 C28.2367417,6.84455415 28.4287553,5.54004027 27.9934977,4.24515971 C27.3924468,2.4501486 25.8224536,1.35596249 24.4852164,1.80029999 C23.4864232,2.13064305 22.9043317,3.22844166 22.9249046,4.52974443 C21.9628198,4.97689166 21.0394605,5.46618471 20.7768538,5.65724582 C20.7768538,5.65724582 3.31572198,0.477322214 3.20156266,0.422331936 C2.54766776,0.109248603 0.932091524,1.03565416 0.563796617,1.38566527 C0.110789849,1.78705416 1.00752542,2.22858194 1.00752542,2.24022221 C1.00752542,2.25186249 19.3371555,11.5123055 22.8309147,13.0163097 C20.9797588,14.0571111 19.5279589,14.8960139 19.1007691,15.1838097 C17.6880979,16.1427278 17.4993115,15.4515361 17.4448538,15.4314666 C17.3565115,15.4013625 15.6183047,12.3805097 15.3871624,12.3142805 C15.163281,12.2512625 14.220559,12.9781778 14.0741285,13.3578917 C13.9986946,13.5505583 13.8768709,14.8759444 13.7764268,16.1226583 C12.4512912,16.0724847 11.1620574,16.0255222 10.9393862,16.0154875 C10.509776,15.9982278 10.224176,16.1383125 10.0765354,16.2161819 C9.93212182,16.2868264 9.77641335,16.4124611 9.62715911,16.5778333 C9.47548454,16.7436069 9.52631166,17.0193611 9.78851504,17.0896041 C9.91033877,17.129743 12.2491929,17.7719653 13.6207183,18.0930764 C13.6049861,18.2961791 13.5961116,18.4173986 13.5961116,18.4173986 C13.5037353,18.9392041 13.5961116,19.5011486 14.0398404,19.5344639 C22.7086876,20.3372416 31.0741857,16.8836916 35.6691992,14.9361528 C41.4893075,15.4178194 49.3441141,16.3811528 49.3441141,16.3646958 C49.3441141,16.3482389 50.1137819,16.3024805 51.3174971,15.8633611 C52.0214123,15.5904166 52.2461005,15.2291666 51.8427107,15.0686111",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(43.661017, 16.527778)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37183384,0.432012484 C1.26816266,0.122541664 0.527942354,0.229712493 0.295589822,0.30557499 C0.0648508482,0.382240264 -0.00614575899,0.67926803 0.0979288129,0.99235135 C0.203616944,1.31346245 0.460979645,1.51415688 0.662674552,1.43106939 C0.90551522,1.33874995 1.4569491,0.736666638 1.37627113,0.415555541",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(39.389831, 17.000000)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99799668,0.65700279 C3.97258312,0.583147233 3.95685092,0.510094453 3.94273228,0.441055563 L3.94515262,0.441055563 C3.41953566,0.738083348 3.00928819,0.924327797 2.68697971,1.03711808 C2.07221359,1.80256671 1.2581729,2.565607 0.241227114,3.23351813 L0.174264401,3.28770563 C1.34046443,3.19618896 4.98710857,1.66770004 5.22188146,1.24744586 C5.16581027,1.29802086 5.09844417,1.3401667 5.02341366,1.36425003 C4.6325289,1.50875003 4.15491533,1.18763891 3.9935594,0.665833346",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(28.474576, 18.888889)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.292789837,1.40002081 L0.528772898,1.28442081 C0.63123392,1.24066943 0.713525449,1.11182359 0.7115085,1.00023749 L0.713525449,0.296201388 C0.715542399,0.183411112 0.63123392,0.128019447 0.528772898,0.174179168 L0.290772887,0.289779166 C0.188311866,0.332727776 0.107633896,0.461172218 0.107633896,0.572356938 L0.107633896,1.2775972 C0.107633896,1.3859722 0.185084747,1.42611109 0.306101702,1.3859722",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(29.423729, 18.416667)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.340413572,1.36850001 L0.576396634,1.25450557 C0.678857655,1.2099514 0.761149184,1.08110556 0.761149184,0.968716674 L0.761149184,0.265884723 C0.761149184,0.153495833 0.676840706,0.0985055545 0.576396634,0.145066666 L0.338800013,0.258659723 C0.236742381,0.30321389 0.153644072,0.429651391 0.155661021,0.542843059 L0.153644072,1.26534307 C0.152030513,1.37652779 0.244406788,1.41666668 0.325084758,1.37652779",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(25.627119, 20.305556)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.447620327,0.228602783 L0.211637282,0.342195841 C0.109176268,0.388355564 0.0252711857,0.514793066 0.0284983042,0.623168068 L0.0264813551,1.32800697 C0.0264813551,1.44842364 0.107159319,1.48856253 0.228176265,1.45123336 L0.466176258,1.33603475 C0.569444052,1.28987502 0.652945745,1.16223336 0.650928795,1.05104863 L0.653349134,0.34620973 C0.632372864,0.250277784 0.531525409,0.170000005 0.450847445,0.210138894",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(26.576271, 19.833333)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.497261027,0.197884727 L0.259664413,0.312280556 C0.155589835,0.356433333 0.0745084781,0.484877773 0.0745084781,0.593252769 L0.0728949187,1.29769024 C0.0745084781,1.41810691 0.153572886,1.45824579 0.274589837,1.41890968 L0.512186451,1.30531663 C0.612630521,1.26116386 0.695325437,1.13271942 0.695325437,1.02033053 L0.695325437,0.31468889 C0.682820352,0.200694449 0.590847469,0.160555562 0.510169502,0.200694449",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(22.305085, 20.777778)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.645803396,0.395793063 L0.408206782,0.510590286 C0.307359323,0.55594723 0.223050847,0.68278612 0.223050847,0.795977787 L0.223050847,1.49961251 C0.224664406,1.62002918 0.303728814,1.66016807 0.424745765,1.62163474 L0.66032543,1.50563335 C0.763996618,1.46107918 0.845481365,1.33223335 0.845077976,1.22064723 L0.845481365,0.517012508 C0.830959331,0.420277785 0.747457635,0.340000007 0.626440684,0.380138896",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(23.254237, 20.305556)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.695444043,0.365074989 L0.456233883,0.480674992 C0.354579649,0.52522916 0.272691517,0.651265275 0.272691517,0.765661111 L0.272691517,1.46929585 C0.272691517,1.58971252 0.35336948,1.62985141 0.474386424,1.59091669 L0.711983026,1.4749153 C0.81283048,1.42955835 0.895525392,1.30231807 0.895525392,1.19073196 L0.897138951,0.486294437 C0.87858302,0.370694434 0.806779632,0.330555544 0.685762688,0.370694434",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(31.322034, 17.472222)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.371522032,1.34720274 L0.609118634,1.23160275 C0.709966089,1.18704858 0.79427456,1.05739997 0.79427456,0.945011088 L0.79427456,0.24298194 C0.79427456,0.130191665 0.711579648,0.0760041666 0.607505075,0.12136111 L0.369908473,0.236961107 C0.269061018,0.281113883 0.186366106,0.40755138 0.186366106,0.521144432 L0.186366106,1.22397636 C0.184752546,1.31749997 0.282372882,1.39777774 0.363050846,1.35763885",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(32.271186, 17.000000)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.419549163,1.31487921 L0.65714578,1.19968059 C0.7596068,1.15472504 0.841898328,1.02708336 0.840688159,0.915095861 L0.841898328,0.211862507 C0.841898328,0.0998750033 0.7596068,0.044483335 0.655532221,0.0906430586 L0.417935604,0.205038895 C0.315877974,0.248790286 0.233989836,0.378037512 0.233989836,0.489222237 L0.232376276,1.21172226 C0.234393226,1.3080556 0.301355939,1.34819449 0.422372892,1.3080556",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(35.593220, 13.694444)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0721118654,1.07055142 C1.18546782,0.703681963 2.77926107,0.192713893 3.26292548,0.138927781 C3.26292548,0.138927781 2.49648479,0.0470097228 1.75949156,0.0185111109 C0.55819662,-0.0272472237 0.115677968,0.270984729 0.115677968,0.270984729 C0.115677968,0.270984729 -0.107800002,1.12152781 0.0854237301,1.08138892",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(26.101695, 10.388889)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24493222,2.04845272 C1.58176274,1.93766939 2.40629158,1.0566208 2.25663395,0.60425554 C2.10495937,0.155904165 1.03355595,0.31164305 0.697128816,0.421222213 C0.366349144,0.532406932 0.263888124,0.963899974 0.415159315,1.41425829 C0.565220337,1.85819439 0.904067805,2.17930549 1.22677968,2.05888883",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(20.406780, 11.333333)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34364051,1.53188895 C7.2609456,1.60654729 7.16332526,1.66434729 7.05441001,1.69244452 C6.48926087,1.88190008 5.82447445,1.41709173 5.57074225,0.65846669 C5.53363038,0.554105574 5.50983038,0.44894168 5.49369479,0.346587509 L5.49571174,0.356622232 C3.57799653,1.43796395 2.71675926,1.51623479 2.33595927,1.40023339 C2.100783,2.16608343 1.09230845,3.74273906 0.0386542375,4.47768215 C1.7284542,4.36569464 7.00237272,2.15805565 7.32508458,1.5158334",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(15.186441, 13.694444)",
    fill: "#97999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6793993,0.377352773 C27.3486196,1.04044722 27.034379,1.39326805 26.3937959,1.86249166 C25.6196909,2.4244361 21.6535621,5.05152637 8.83746418,9.72489719 C5.59703376,10.9073889 2.04962368,11.464918 0.774508462,11.2080291 L0.774105073,11.2080291 L0.749901683,11.2028111 C0.709562701,11.1939805 0.670433889,11.1839458 0.633725415,11.1735097 C0.545786434,11.1502291 0.425172878,11.1209277 0.282776272,11.0815916 C0.267044069,11.4829805 0.363454236,11.8040916 0.686166092,11.8442305 C9.40220993,12.6470083 17.8830775,8.91047914 22.1392435,7.10623609 C26.4184027,5.2959722 28.0759315,1.60319444 27.6725416,0.358888884",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(7.118644, 26.916667)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.467932204,11.3291776 C4.95887101,16.1057053 11.3594572,19.075983 18.4187789,19.075983 C29.5474971,19.075983 38.9472866,11.7225387 41.9904593,1.63322775 C38.2937951,0.67190138 34.417219,0.157320833 30.4180124,0.157320833 C18.9593213,0.181805555 8.47118612,4.35624993 0.484067797,11.3404165",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.688136, 30.954168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_8_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    mask: "url(#mask-11)",
    points: "39.2901703 -8.95097219 45.4620348 17.7413878 2.3396612 27.6556929 -3.8725423 0.96333294"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(42.877965, 6.256944)",
    fill: "#0077BE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0.631186428 0.212499994 0.227796605 0.212499994 0.227796605 0.09208333 1.19593218 0.09208333 1.19593218 0.212499994 0.792542357 0.212499994 0.792542357 1.29624997 0.631186428 1.29624997"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.949153, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0.367796599 0.09208333 0.56949151 0.09208333 0.972881333 1.09555553 1.33593217 0.09208333 1.57796607 0.09208333 1.57796607 1.29624997 1.41661014 1.29624997 1.41661014 0.292777771 1.41661014 0.292777771 1.0535593 1.29624997 0.892203369 1.29624997 0.529152528 0.292777771 0.529152528 0.292777771 0.529152528 1.29624997 0.367796599 1.29624997"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e259cb434b21ee849a573f0eb0039be3.svg";
export { ForwardRef as ReactComponent };